//=================================================
//    summary: DCP 檔案下載 書本 資源列表 視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/17 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssResourceVolume from './ResourceVolume.module.scss'

import { FixedSizeList as List } from "react-window"

import { ResourceTypeEnum } from '../../../Resource/Resource.js'
import {ClientGatewayInPackage, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Const
const COMP_NAME = "ResourceVolume"

const DEFAULT_PDF_FILE_NAME = "Resource.pdf"
// #endregion Const

// #region Enumeration
const RowTypeEnum = {
    "LessonListMore": 1,
    "LessonListOne": 2,
    "FileList4Lesson": 3,
    "FileList": 4
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mblnExpired = false
let mobjResourceVolume = null
let marrSource = []
let marrShowUnit = []
let marrDisplaySource = []
let mobjAudioPlayInfo = null
let mblnUpdateListContentHeight = false

let mstrDownloadFileName = ""
// #endregion Member Variables


function ResourceVolume(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [listContentHeight, setListContentHeight] = useState(618)
    // #endregion Init State

    // #region Init Ref
    let mrefListContent = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update updateDataTime
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect updateDataTime")

        if (
            (mblnUpdateListContentHeight) &&
            (typeof(mrefListContent.current) !== 'undefined') &&
            (mrefListContent.current !== null) &&
            (typeof(mrefListContent.current.clientHeight) !== 'undefined') &&
            (mrefListContent.current.clientHeight !== null) &&
            (mrefListContent.current.clientHeight > 0)
            )
        {
            mblnUpdateListContentHeight = false
            setListContentHeight(mrefListContent.current.clientHeight)
        }
    }, [updateDataTime])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mrefCleanUp.current()
        }
    }, [props.BookSeqNo, props.ResourceType])

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(AudioCanplayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)

        window.addEventListener("resize", WindowOnResizeEventHandler)

        // 強制讓 Setting 購買的授權 同步到 這邊的授權  Tim19.09.04
        mblnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(props.BookSeqNo))

        mobjCallParam = {
            "BookCategoryID": window.gSession.App.BookCatID,
            "BookSeqNo": parseInt(props.BookSeqNo),
            "ResourceType": parseInt(props.ResourceType)
        }
        GetDCPResource()
    } // end of PaintedMe
    
    /*===========================================
    summary: componentWillUnmount 程式離開 處理資料
    remarks: 000 Tim 2022/06/23 Create
    ===========================================*/
    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.StopAudio()

        window.removeEventListener('resize', WindowOnResizeEventHandler)

        mblnInitialized = false
        mblnExpired = false
        mobjResourceVolume = null
        marrSource = []
        marrShowUnit = []
        marrDisplaySource = []
        mobjAudioPlayInfo = null
        mblnUpdateListContentHeight = false
        mstrDownloadFileName = ""

        setUpdateDataTime(0)
    } // end of CleanUp
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 返回 Resource 頁面
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function BackOnTapHandler()
    {
        console.log(COMP_NAME + ".BackOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowResourceVolume"
        }
        props.CallbackRef(objCallbackData)
    } // end of BackOnTapHandler

    /*===========================================
    summary: 點選 整本書 全部下載
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function VolumeDownloadAllOnTapHandler()
    {
        console.log(COMP_NAME + ".VolumeDownloadAllOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        WebDownloadFileProcess(mobjResourceVolume.Volume.FileName)
    } // end of VolumeDownloadAllOnTapHandler

    /*===========================================
    summary: 點選 單一列資料 下載
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function DownloadOnTapHandler(FileName)
    {
        console.log(COMP_NAME + ".DownloadOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        WebDownloadFileProcess(FileName)
    } // end of DownloadOnTapHandler

    /*===========================================
    summary: 點選 顯示 / 關閉
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ShowHideOnTapHandler(LessonIndex)
    {
        console.log(COMP_NAME + ".ShowHideOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        marrShowUnit[LessonIndex] = !marrShowUnit[LessonIndex]

        marrDisplaySource = GetDisplaySource(parseInt(props.ResourceType))

        console.log(COMP_NAME + ".ShowHideOnTapHandler marrDisplaySource: ", marrDisplaySource)

        setUpdateDataTime(new Date().getTime())
    } // end of ShowHideOnTapHandler

    /*===========================================
    summary: 點選 單一列資料 下載
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ViewOnTapHandler(FileName)
    {
        console.log(COMP_NAME + ".ViewOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        // View
        AppViewPDFFileProcess(FileName)
    } // end of ViewOnTapHandler

    /*===========================================
    summary: 點選 單一列資料 聲音播放
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function AudioPlayOnTapHandler(FileName, LessonIndex, FileIndex, IsAudioPlay)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler: ", FileName, LessonIndex, FileIndex, IsAudioPlay)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (mobjAudioPlayInfo !== null)
        {
            SetDisplaySourceAudioEnd(mobjAudioPlayInfo.LessonIndex, mobjAudioPlayInfo.FileIndex)
        }

        if (!IsAudioPlay)
        {
            let strUrl = PackageVariablesLibs.SysConfig.FileServerURL + FileName

            SetDisplaySourceAudioPlay(LessonIndex, FileIndex)

            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)

            window.AudioLibs.PlayAudio(strUrl)
        }
        else
        {
            window.AudioLibs.StopAudio()
        }
    } // end of AudioPlayOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        if (mobjAudioPlayInfo !== null)
        {
            SetDisplaySourceAudioEnd(mobjAudioPlayInfo.LessonIndex, mobjAudioPlayInfo.FileIndex)
        }
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: 音檔 讀取完畢 可以播放 
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function AudioCanplayHandler()
    {
        console.log(COMP_NAME + ".AudioCanplayHandler")

        CloseLoadingMask()
    } // end of AudioCanplayHandler

    /*===========================================
    summary: 改變視窗大小
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function WindowOnResizeEventHandler()
    {
        // console.log(COMP_NAME + ".WindowOnResizeEventHandler")
        
        if (
            (typeof(mrefListContent.current) !== 'undefined') &&
            (mrefListContent.current !== null) &&
            (typeof(mrefListContent.current.clientHeight) !== 'undefined') &&
            (mrefListContent.current.clientHeight !== null) &&
            (mrefListContent.current.clientHeight > 0)
            )
        {
            setListContentHeight(mrefListContent.current.clientHeight)
        }
    } // end of WindowOnResizeEventHandler
    // #endregion Other EventHandler

    // #region LoadingMask Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2022/04/20 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2022/04/20 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2022/04/20 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask Functions

    // #region Other Functions
    /*===========================================
    summary: 取得 顯示 資料 列表
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function GetDisplaySource(ResourceType)
    {
        console.log(COMP_NAME + ".GetDisplaySource ResourceType: ", ResourceType)

        let objDisplaySource = null
        let arrDisplaySource = []

        let intIndex4Source = 0
        let intCount4Source = marrSource.length
        let intIndex4SubSource = 0
        let intCount4SubSource = 0

        if (
            (ResourceType === ResourceTypeEnum.Textbook) ||
            (ResourceType === ResourceTypeEnum.Workbook)
            )
        {
            for (intIndex4Source = 0; intIndex4Source < intCount4Source; intIndex4Source++)
            {
                objDisplaySource = JSON.parse(JSON.stringify(marrSource[intIndex4Source]))
                
                if (marrSource[intIndex4Source].FileList.length > 1)
                {
                    objDisplaySource.RowType = RowTypeEnum.LessonListMore
                    objDisplaySource.IsShow = marrShowUnit[intIndex4Source]
                    objDisplaySource.FileList = null
                }
                else
                {
                    objDisplaySource.RowType = RowTypeEnum.LessonListOne
                    objDisplaySource.IsAudioPlay = false
                }
                objDisplaySource.LessonIndex = intIndex4Source

                arrDisplaySource.push(objDisplaySource)

                if (
                    (marrSource[intIndex4Source].FileList.length > 1) &&
                    (marrShowUnit[intIndex4Source])
                    )
                {
                    intIndex4SubSource = 0
                    intCount4SubSource = marrSource[intIndex4Source].FileList.length

                    for (intIndex4SubSource = 0; intIndex4SubSource < intCount4SubSource; intIndex4SubSource++)
                    {
                        objDisplaySource = JSON.parse(JSON.stringify(marrSource[intIndex4Source].FileList[intIndex4SubSource]))
                        objDisplaySource.RowType = RowTypeEnum.FileList4Lesson
                        objDisplaySource.LessonIndex = intIndex4Source
                        objDisplaySource.FileIndex = intIndex4SubSource
                        objDisplaySource.LessonID = marrSource[intIndex4Source].LessonID
                        objDisplaySource.IsAudioPlay = false

                        arrDisplaySource.push(objDisplaySource)
                    } // end of for (intIndex4SubSource = 0;
                } // end of if
            } // end of for (intIndex4Source = 0;
        }
        else if (
            (ResourceType === ResourceTypeEnum.WorkbookAnswerKey) ||
            (ResourceType === ResourceTypeEnum.Assessment)
            )
        {
            for (intIndex4Source = 0; intIndex4Source < intCount4Source; intIndex4Source++)
            {
                objDisplaySource = JSON.parse(JSON.stringify(marrSource[intIndex4Source]))
                objDisplaySource.RowType = RowTypeEnum.FileList
                objDisplaySource.LessonIndex = -1
                objDisplaySource.FileIndex = intIndex4Source
                objDisplaySource.IsAudioPlay = false

                arrDisplaySource.push(objDisplaySource)
            } // end of for (intIndex4Source = 0;
        }

        console.log(COMP_NAME + ".GetDisplaySource END arrDisplaySource: ", arrDisplaySource)

        return arrDisplaySource
    } // end of GetDisplaySource

    /*===========================================
    summary: 設定 顯示資料 音檔開始播放
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function SetDisplaySourceAudioPlay(LessonIndex, FileIndex)
    {
        console.log(COMP_NAME + ".SetDisplaySourceAudioPlay")

        let intIndex = 0
        let intCount = marrDisplaySource.length
        let blnFound = false

        while ((!blnFound) && (intIndex < intCount))
        {
            if (marrDisplaySource[intIndex].RowType === RowTypeEnum.LessonListOne)
            {
                if (
                    (typeof(marrDisplaySource[intIndex].LessonIndex) !== 'undefined') &&
                    (marrDisplaySource[intIndex].LessonIndex !== null) &&
                    (parseInt(marrDisplaySource[intIndex].LessonIndex) === LessonIndex)
                    )
                {
                    marrDisplaySource[intIndex].IsAudioPlay = true
                    blnFound = true
                } // end of if (parseInt(marrDisplaySource[intIndex].LessonIndex) === LessonIndex)
            }
            else
            {
                if (
                    (typeof(marrDisplaySource[intIndex].LessonIndex) !== 'undefined') &&
                    (marrDisplaySource[intIndex].LessonIndex !== null) &&
                    (typeof(marrDisplaySource[intIndex].FileIndex) !== 'undefined') &&
                    (marrDisplaySource[intIndex].FileIndex !== null) &&

                    (parseInt(marrDisplaySource[intIndex].LessonIndex) === LessonIndex) &&
                    (parseInt(marrDisplaySource[intIndex].FileIndex) === FileIndex)
                    )
                {
                    marrDisplaySource[intIndex].IsAudioPlay = true
                    blnFound = true
                }
            }
            intIndex++
        } // end of while

        console.log(COMP_NAME + ".SetDisplaySourceAudioPlay marrDisplaySource: ", marrDisplaySource)

        if (blnFound)
        {
            mobjAudioPlayInfo = {
                "LessonIndex": LessonIndex,
                "FileIndex": FileIndex
            }

            setUpdateDataTime(new Date().getTime())
        } // end of if (blnFound)
    } // end of SetDisplaySourceAudioPlay

    /*===========================================
    summary: 設定 顯示資料 音檔開始結束
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function SetDisplaySourceAudioEnd(LessonIndex, FileIndex)
    {
        console.log(COMP_NAME + ".SetDisplaySourceAudioEnd")

        let intIndex = 0
        let intCount = marrDisplaySource.length
        let blnFound = false

        while ((!blnFound) && (intIndex < intCount))
        {
            if (marrDisplaySource[intIndex].RowType === RowTypeEnum.LessonListOne)
            {
                if (
                    (typeof(marrDisplaySource[intIndex].LessonIndex) !== 'undefined') &&
                    (marrDisplaySource[intIndex].LessonIndex !== null) &&
                    (parseInt(marrDisplaySource[intIndex].LessonIndex) === LessonIndex)
                    )
                {
                    marrDisplaySource[intIndex].IsAudioPlay = false
                    blnFound = true
                } // end of if (parseInt(marrDisplaySource[intIndex].LessonIndex) === LessonIndex)
            }
            else
            {
                if (
                    (typeof(marrDisplaySource[intIndex].LessonIndex) !== 'undefined') &&
                    (marrDisplaySource[intIndex].LessonIndex !== null) &&
                    (typeof(marrDisplaySource[intIndex].FileIndex) !== 'undefined') &&
                    (marrDisplaySource[intIndex].FileIndex !== null) &&

                    (parseInt(marrDisplaySource[intIndex].LessonIndex) === LessonIndex) &&
                    (parseInt(marrDisplaySource[intIndex].FileIndex) === FileIndex)
                    )
                {
                    marrDisplaySource[intIndex].IsAudioPlay = false
                    blnFound = true
                }
            }
            intIndex++
        } // end of while

        mobjAudioPlayInfo = null

        if (blnFound)
        {
            setUpdateDataTime(new Date().getTime())
        }
    } // end of SetDisplaySourceAudioEnd

    /*===========================================
    summary: Web 下載 PDF檔案 流程，增加隱藏網址 防盜機制
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function WebDownloadFileProcess(FileName)
    {
        console.log(COMP_NAME + ".WebDownloadFileProcess: FileName: ", FileName)

        // // 網址顯示機制
        // let strDownloadUrl = PackageVariablesLibs.SysConfig.DownloadServer + FileName + '&FileType=3'
        // window.open(strDownloadUrl, '_parent')

        // 取得路經中的檔名及副檔名
        mstrDownloadFileName = FileName.replace(/^.*[/]/, '')
        console.log(COMP_NAME + ".WebDownloadFileProcess mstrDownloadFileName: ", mstrDownloadFileName)

        // Web 在這邊 顯示LoadingMask  讀取資料, 下載處理等等流程，最後才關閉
        // Open Loading mask with message
        OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetListeningPDFFileKeyFromFS)

        mobjCallParam = {
            "FileName": FileName
        }
        console.log(COMP_NAME + ".WebDownloadFileProcess mobjCallParam:", mobjCallParam)
        GetListeningPDFFileKeyFromFS()
    } // end of WebDownloadFileProcess

    /*===========================================
    summary: Web 使用 Blob 下載 PDF檔案
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function ProcessFileDownloadWithBlob(OneTimeKey)
    {
        console.log(COMP_NAME + ".ProcessFileDownloadWithBlob: ", OneTimeKey)

        // let strURL = "https://appfsdev.betterchinese.com/main.php" + "?" + "Func=DownloadFile&DownloadKey=" + strOneTimeKey

        // 目前參數必須寫在 QueryString 無法用 JOSN Post丟過去
        let strURL = PackageVariablesLibs.SysConfig.BlobDownloadServer
        strURL += "?Func=DownloadFile" 
        strURL += "&DownloadKey=" + OneTimeKey
        
        fetch(
            strURL,
            {
                "method": 'POST'
            },
        )
            .then(function (response)
            {
                console.log(COMP_NAME + ".ProcessFileDownloadWithBlob response.type: ", response.type) // returns basic by default

                response.blob().then(function (objBlob)
                {
                    let objURL = URL.createObjectURL(objBlob)
                    console.log(COMP_NAME + ".ProcessFileDownloadWithBlob objURL: ", objURL)

                    let strFilename = DEFAULT_PDF_FILE_NAME
                    if (mstrDownloadFileName !== "")
                    {
                        strFilename = mstrDownloadFileName
                    } // end of if (mstrDownloadFileName !== "")

                    WebAutoDownload(strFilename, objURL)    
                });
            }) // end of then(function (response)
            .catch(error => {
                console.log(COMP_NAME + ".ProcessFileDownloadWithBlob fetch err: ", error)

                if (!window.gSession.App.InApp)
                {
                    // Web 發生錯誤 關閉 LoadingMask
                    CloseLoadingMask()
                } // end of if (!window.gSession.App.InApp)

                let objAlertObject = {
                    Header: null,
                    Body: window.gAppUI.ERR_DownloadFileFail,
                    ShowCloseButton: false,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            }) // end of catch
    } // end of ProcessFileDownloadWithBlob

    /*===========================================
    summary: Web 自動下載
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function WebAutoDownload(FileName, UrlObject)
    {
        console.log(COMP_NAME + ".WebAutoDownload: ")
        console.log(COMP_NAME + ".WebAutoDownload FileName: ", FileName)
        console.log(COMP_NAME + ".WebAutoDownload UrlObject: ", UrlObject)

        let objElement = document.createElement('a')
        objElement.setAttribute('href', UrlObject)
        objElement.setAttribute('download', FileName)
        objElement.style.display = 'none'
        document.body.appendChild(objElement)
        objElement.click()
        document.body.removeChild(objElement)

        if (!window.gSession.App.InApp)
        {
            // Web 發生錯誤 關閉 LoadingMask
            CloseLoadingMask()
        } // end of if (!window.gSession.App.InApp)
    } // end of WebAutoDownload

    /*===========================================
    summary: App 觀看 PDF檔案 流程
    remarks: 000 Tim 2023/04/19 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function AppViewPDFFileProcess(FileName)
    {
        const FUNC_NAME = AppViewPDFFileProcess.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": FileName: ", FileName)

        if (window.gSession.App.iOSNewGateway)
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " SwiftUI")
            
            // 取得路經中的檔名及副檔名
            mstrDownloadFileName = FileName.replace(/^.*[/]/, '')
            console.log(COMP_NAME + "." + FUNC_NAME + " mstrDownloadFileName: ", mstrDownloadFileName)

            mobjCallParam = {
                "FileName": FileName
            }
            console.log(COMP_NAME + "." + FUNC_NAME + " mobjCallParam:", mobjCallParam)
            GetListeningPDFFileKeyFromFS()
        } // end of if (window.gSession.App.iOSNewGateway)
        else
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " Not SwiftUI")

            let intPreX = 0
            let intPreY = 0

            let intAction = window.gConst.ACTION_OPEN_PDF;
            let strQueryString = "Action=" + intAction 
            strQueryString += "&Credential=" + window.gSession.Acc.Credential 
            strQueryString += "&BackRoute="
            strQueryString += "&FN=" + FileName
            strQueryString += "&PosX=" + intPreX
            strQueryString += "&PosY=" + intPreY

            console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString:", strQueryString)

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of AppViewPDFFileProcess
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 音檔播放 按鈕 Cls
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function GetAudioPlayCls(IsAudioPlay)
    {
        let objCls = ""
        if (!window.gSession.App.InApp)
        {
            if (IsAudioPlay)
            {
                objCls = cssResourceVolume.btnAudioStop
            }
            else
            {
                objCls = cssResourceVolume.btnAudioPlay
            }
        }
        else
        {
            if (IsAudioPlay)
            {
                objCls = cssResourceVolume.btnAudioStop4App
            }
            else
            {
                objCls = cssResourceVolume.btnAudioPlay4App
            }
        }

        return objCls
    } // end of GetAudioPlayCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 取得下載PDF用的OntTimeKey 資料讀取完畢  iOSNewGateway下載流程
    remarks: 000 Tim 2023/04/20 Create
             001 Tim 2023/05/25 原 ACTION_OPEN_PDF: 18 -> ACTION_SHARE_FILE_WITH_ANOTHER: 40
             002 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             003 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function GetListeningPDFFileKeyFromFSAfterProcess(ReturnData)
    {
        const FUNC_NAME = GetListeningPDFFileKeyFromFSAfterProcess.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", ReturnData)

        if (
            (ReturnData !== null) &&
            (typeof(ReturnData.FileList) !== "undefined") &&
            (ReturnData.FileList !== null) &&
            (Array.isArray(ReturnData.FileList)) &&
            (ReturnData.FileList.length > 0)
            )
        {
            let strOneTimeKey = ReturnData.FileList[0].OneTimeKey
            console.log(COMP_NAME + "." + FUNC_NAME + " strOneTimeKey:", strOneTimeKey)

            if (!window.gSession.App.InApp)
            {
                // Web
                ProcessFileDownloadWithBlob(strOneTimeKey)
            } // end of if (!window.gSession.App.InApp)
            else
            {
                // App
                // // 原 ACTION_OPEN_PDF: 18 -> ACTION_SHARE_FILE_WITH_ANOTHER: 40
                // let intAction = window.gConst.ACTION_OPEN_PDF
                // let strQueryString = "Action=" + intAction
                // strQueryString += "&Credential=" + window.gSession.Acc.Credential
                // strQueryString += "&BackRoute="
                // strQueryString += "&DownloadOneTimeKey=" + strOneTimeKey
                // strQueryString += "&FileName=" + mstrDownloadFileName

                let strFileUrl = PackageVariablesLibs.SysConfig.BlobDownloadServer
                strFileUrl += "?Func=DownloadFile"
                strFileUrl += "&DownloadKey=" + strOneTimeKey

                let intAction = window.gConst.ACTION_SHARE_FILE_WITH_ANOTHER
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential="
                strQueryString += "&BackRoute="
                strQueryString += "&FileUrl=" + encodeURIComponent(strFileUrl)
                strQueryString += "&NewFileName=" + encodeURIComponent(mstrDownloadFileName)

                console.log(COMP_NAME + "." + FUNC_NAME + " ACTION_SHARE_FILE_WITH_ANOTHER strQueryString: ", strQueryString)

                // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
                ClientGatewayInPackage.CallApp(strQueryString)
            } // end of else
        } // end of if (ReturnData.FileList.length > 0)
    } // end of GetListeningPDFFileKeyFromFSAfterProcess

    /*===========================================
    summary: 取得ResourceVolume 資訊 後續流程
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function GetDCPResourceAfterProcess (ReturnData)
    {   
        console.log(COMP_NAME + ".GetDCPResourceAfterProcess")

        mobjResourceVolume = ReturnData

        marrSource = []
        marrShowUnit = []

        if (
            (parseInt(props.ResourceType) === ResourceTypeEnum.Textbook) ||
            (parseInt(props.ResourceType) === ResourceTypeEnum.Workbook)
            )
        {
            marrSource = mobjResourceVolume.Volume.LessonList

            if (marrSource[0].FileList.length > 1)
            {
                let intIndex = 0
                let intCount = marrSource.length

                for (intIndex = 0; intIndex < intCount; intIndex++)
                {
                    marrShowUnit.push(false)
                } // end of for (intIndex = 0;
            } // end of if (marrSource[0].FileList.length > 1)
        }
        else if (
            (parseInt(props.ResourceType) === ResourceTypeEnum.WorkbookAnswerKey) ||
            (parseInt(props.ResourceType) === ResourceTypeEnum.Assessment)
            )
        {
            marrSource = mobjResourceVolume.Volume.FileList
        }

        marrDisplaySource = GetDisplaySource(parseInt(props.ResourceType))

        console.log(COMP_NAME + ".GetDCPResourceAfterProcess marrDisplaySource: ", marrDisplaySource)

        mblnUpdateListContentHeight = true

        setUpdateDataTime(new Date().getTime())
    } // end of GetDCPResourceAfterProcess
    // #endregion Web Service After Process

    // #region Web Service 
    /*===========================================
    summary: 取得 ResourceVolume 資料
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function GetDCPResource ()
    {
        console.log(COMP_NAME + ".GetDCPResource")

        let objRetryFuncRef = GetDCPResource
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetDCPResourceCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetDCPResource)

            let objCallData = {
                "Func": "GetDCPResource",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "BookSeqNo": mobjCallParam.BookSeqNo,
                "ResourceType": mobjCallParam.ResourceType
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetDCPResource

    /*===========================================
    summary: 取得 ResourceVolume 資料 Callback
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function GetDCPResourceCallback (Return)
    {
        console.log(COMP_NAME + ".GetDCPResourceCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetDCPResource_No
        let strErrorTitle = window.gAppUI.ERR_GetDCPResource_Title
        let strErrMsg = window.gAppUI.ERR_GetDCPResource_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            console.log("GetDCPResourceCallback: ErrNo: ", Return.ErrNo)
            console.log("GetDCPResourceCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetDCPResourceCallback Return.Data: ", Return.Data)

            GetDCPResourceAfterProcess(Return.Data)
        }
    } // end of GetDCPResourceCallback

    /*===========================================
    summary: 取得下載PDF用的OntTimeKey
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function GetListeningPDFFileKeyFromFS()
    {
        let objRetryFuncRef = GetListeningPDFFileKeyFromFS

        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        } // end of if (!window.navigator.onLine)
        else
        {
            let objCallbackFuncRef = GetListeningPDFFileKeyFromFSCallback
            let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_BC_LEANING

            if (window.gSession.App.InApp)
            {
                // App 才在這邊 顯示 讀取資料 LoadingMask
                // Open Loading mask with message
                OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetListeningPDFFileKeyFromFS)
            } // end of if (window.gSession.App.InApp)

            let objCallData = {
                "Func": "GetListeningPDFFileKeyFromFS",
                "FileName": mobjCallParam.FileName,                
            }
            // console.log("GetListeningPDFFileKeyFromFS.objCallData: ", objCallData)
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef, intWSServerType)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        } // end of else
    } // end of GetListeningPDFFileKeyFromFS

    /*===========================================
    summary: 取得下載PDF用的OntTimeKey Callback
    remarks: 000 Tim 2023/04/19 Create
    ===========================================*/
    function GetListeningPDFFileKeyFromFSCallback(Return)
    {
        // console.log(COMP_NAME + ".GetListeningPDFFileKeyFromFSCallback: ", Return)

        if (window.gSession.App.InApp)
        {
            // App 才在這邊 顯示 讀取資料 LoadingMask
            // Close Loading mask
            CloseLoadingMask()
        } // end of if (window.gSession.App.InApp)

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetListeningPDFFileKeyFromFS_No
        let strErrorTitle = window.gAppUI.ERR_GetListeningPDFFileKeyFromFS_Title
        let strErrMsg = window.gAppUI.ERR_GetListeningPDFFileKeyFromFS_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)
            console.log("GetListeningPDFFileKeyFromFSCallback: ErrNo: ", Return.ErrNo)
            console.log("GetListeningPDFFileKeyFromFSCallback: CalledErrNo: ", Return.CalledErrNo)
        } // end of if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        else
        {
            console.log("GetListeningPDFFileKeyFromFSCallback Return.Data: ", Return.Data)

            GetListeningPDFFileKeyFromFSAfterProcess(Return.Data)
        } // end of else
    } // end of GetListeningPDFFileKeyFromFSCallback
    // #endregion Web Service 

    // #region Render元件
    /*===========================================
    summary: Source File List Unit Title Cell 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentSourceFileListUnitTitleCell( {Name} )
    {
        return(
            <div className={cssResourceVolume.divUnitTitleCell}>
                <div className={cssResourceVolume.divUnitTitle4FileList}>
                    {Name}
                </div>
            </div>
        )
    } // end of ComponentSourceFileListUnitTitleCell
                
    /*===========================================
    summary: Source File Button 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentSourceFileButton( {FileName} )
    {
        if (!window.gSession.App.InApp)
        {
            return(
                <div className={cssResourceVolume.btnDownload4Unit} onClick={() => DownloadOnTapHandler(FileName)}/>
            )
        }
        else if (FileName.indexOf('.mp3') === -1)
        {
            return(
                <div className={cssResourceVolume.btnView} onClick={() => ViewOnTapHandler(FileName)}/>
            )
        } 
        else
        {
            return ""
        } 
    } // end of ComponentSourceFileButton

    /*===========================================
    summary: Source Audio Play Button 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentSourceAudioPlayButton( {FileName, LessonIndex, FileIndex, IsAudioPlay} )
    {
        if (FileName.indexOf('.mp3') !== -1)
        {
            return(
                <div className={GetAudioPlayCls(IsAudioPlay)} onClick={() => AudioPlayOnTapHandler(FileName, LessonIndex, FileIndex, IsAudioPlay)}/>
            )
        }
        else
        {
            return(
                <div className={cssResourceVolume.btnAudioPlayNull}/>
            )
        }  
    } // end of ComponentSourceAudioPlayButton               

    /*===========================================
    summary: Source Unit Title Cell 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentSourceUnitTitleCell( {Name} )
    {
        return(
            <div className={cssResourceVolume.divUnitTitleCell}>
                <div className={cssResourceVolume.divUnitTitle}>
                    {Name}
                </div>
            </div>
        )
    } // end of ComponentSourceUnitTitleCell                    

    /*===========================================
    summary: Source Download All Cell 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentSourceShowHideCell( {LessonIndex, IsShow} )
    {
        let strShowHide = ""

        if (!IsShow)
        {
            strShowHide = window.gAppUI.BTN_Show
        }
        else
        {
            strShowHide = window.gAppUI.BTN_Hide
        }
        
        return(
            <div className={cssResourceVolume.divToolCell}>
                <div className={cssResourceVolume.btnShowHide} 
                        onClick={() => ShowHideOnTapHandler(LessonIndex)}>
                    {strShowHide}
                </div>
            </div> 
        )
    } // end of ComponentSourceShowHideCell
                 
    /*===========================================
    summary: Source Download All Cell 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentSourceDownloadAllCell( {FileName} )
    {
        if (
            (!window.gSession.App.InApp) &&
            (FileName !== null)
            )
        {
            return(
                <div className={cssResourceVolume.divDownloadAllCell}>
                    <div className={cssResourceVolume.btnDownloadAll4Row} 
                        onClick={() => DownloadOnTapHandler(FileName)}/>
                </div>
            )
        }
        else
        {
            return(
                <div className={cssResourceVolume.divDownloadAllCell} />
            )
        }
    } // end of ComponentSourceDownloadAllCell

    /*===========================================
    summary: Source Lesson Name Cell 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentSourceLessonNameCell( {Name} )
    {
        return(
            <div className={cssResourceVolume.divLessonCell}>
                <div className={cssResourceVolume.divLessonName}>
                    {Name}
                </div>
            </div>
        )
    } // end of ComponentSourceLessonNameCell

    /*===========================================
    summary: Download All Button 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentDownloadAllButton( {ResourceType} )
    {   
        if (
            (
                (parseInt(ResourceType) === ResourceTypeEnum.Textbook) ||
                (parseInt(ResourceType) === ResourceTypeEnum.Workbook)
                ) &&
                (!window.gSession.App.InApp)
            )
        {
            return(
                <div className={cssResourceVolume.btnDownloadAll} onClick={() => VolumeDownloadAllOnTapHandler()}/>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentDownloadAllButton

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssResourceVolume.divTitle}>
                {window.gAppUI.LBL_Resource}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: Back Button 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentBackButton()
    {   
        return(
            <div className={cssResourceVolume.btnBack} onClick={() => BackOnTapHandler()}/>
        )
    } // end of ComponentBackButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render 列表 FileList 資料內容 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderSourceRowFileListWrapper(SourceData)
    {
        return (
            <div className={cssResourceVolume.divSourceUnit}>
                <ComponentSourceFileListUnitTitleCell Name={SourceData.Name} />

                {RenderSourceAudioAndFileCellWrapper(SourceData.IsAudioPlay
                    , SourceData.FileName, SourceData.LessonIndex
                    , SourceData.FileIndex)}
            </div>
        )
    } // end of RenderSourceRowFileList4LessonWrapper

    /*===========================================
    summary: Render 列表 Lesson列表裡 FileList 資料內容 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderSourceRowFileList4LessonWrapper(SourceData)
    {
        return (
            <div className={cssResourceVolume.divSourceUnit}>
                <ComponentSourceLessonNameCell Name={""} />

                <ComponentSourceUnitTitleCell Name={SourceData.Name} />

                {RenderSourceAudioAndFileCellWrapper(SourceData.IsAudioPlay
                    , SourceData.FileName, SourceData.LessonIndex
                    , SourceData.FileIndex)}
            </div>
        )
    } // end of RenderSourceRowFileList4LessonWrapper

    /*===========================================
    summary: Render Source Unit Title Cell 顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderSourceAudioAndFileCellWrapper(IsAudioPlay, FileName, LessonIndex, FileIndex)
    {
        return(
            <div className={cssResourceVolume.divToolCell}>
                <ComponentSourceAudioPlayButton FileName={FileName} LessonIndex={LessonIndex} FileIndex={FileIndex} IsAudioPlay={IsAudioPlay} />
                <ComponentSourceFileButton FileName={FileName} />
            </div>
        )
    } // end of RenderSourceAudioAndFileCellWrapper

    /*===========================================
    summary: Render 列表 LessonList 一筆 資料內容 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderSourceRowLessonListOneWrapper(SourceData)
    {
        let intFileIndex = 0

        return (
            <div className={cssResourceVolume.divSourceUnit}>
                <ComponentSourceLessonNameCell Name={SourceData.Name} />

                <ComponentSourceUnitTitleCell Name={SourceData.FileList[intFileIndex].Name} />

                {RenderSourceAudioAndFileCellWrapper(SourceData.IsAudioPlay, SourceData.FileList[intFileIndex].FileName, SourceData.LessonIndex, intFileIndex)}
            </div>
        )
    } // end of RenderSourceRowLessonListOneWrapper

    /*===========================================
    summary: Render 列表 LessonList 多筆 資料內容 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderSourceRowLessonListMoreWrapper(SourceData)
    {
        return (
            <div className={cssResourceVolume.divSourceUnit}>
                <ComponentSourceLessonNameCell Name={SourceData.Name} />

                <ComponentSourceDownloadAllCell FileName={SourceData.FileName} />

                <ComponentSourceShowHideCell LessonIndex={SourceData.LessonIndex} IsShow={SourceData.IsShow} />
            </div>
        )
    } // end of RenderSourceRowLessonListMoreWrapper

    /*===========================================
    summary: Render 列表 資料內容 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderSourceRowWrapper(ListData)
    {
        let objSourceData = marrDisplaySource[ListData.index]

        let objRowBlock = ""

        if (objSourceData.RowType === RowTypeEnum.LessonListMore)
        {
            objRowBlock = RenderSourceRowLessonListMoreWrapper(objSourceData)
        }
        else if (objSourceData.RowType === RowTypeEnum.LessonListOne)
        {
            objRowBlock = RenderSourceRowLessonListOneWrapper(objSourceData)
        }
        else if (objSourceData.RowType === RowTypeEnum.FileList4Lesson)
        {
            objRowBlock = RenderSourceRowFileList4LessonWrapper(objSourceData)
        }
        else if (objSourceData.RowType === RowTypeEnum.FileList)
        {
            objRowBlock = RenderSourceRowFileListWrapper(objSourceData)
        }
        
        return (
            <div className="row" style={ListData.style}>
                {objRowBlock}
            </div>
        )
    } // end of RenderSourceRowWrapper

    /*===========================================
    summary: Render 列表 內容 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderListContentWrapper(StateListContentHeight, StateUpdateDataTime)
    {
        if (marrDisplaySource.length > 0)
        {
            return (
                <div ref={mrefListContent} className={cssResourceVolume.divListContent}>
                    <div className={cssResourceVolume.divSourceList}>
                        <List width={'100%'} height={StateListContentHeight}
                                itemCount={marrDisplaySource.length} itemSize={60}
                                StateUpdateDataTime={StateUpdateDataTime}>
                            {(ListData) => RenderSourceRowWrapper(ListData)}
                        </List>
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderListContentWrapper

    /*===========================================
    summary: Render Content 有資料 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderContent4HaveDataWrapper(StateUpdateDataTime)
    {
        return (
            <div className={cssResourceVolume.divContent}>
                <div className={cssResourceVolume.divTitleMain}>
                    <div className={cssResourceVolume.divVolTitle}>
                        {mobjResourceVolume.Volume.Name}
                    </div>
                    <ComponentDownloadAllButton ResourceType={props.ResourceType} />
                </div>
                <div className={cssResourceVolume.divTitleLine}/>

                {RenderListContentWrapper(listContentHeight, StateUpdateDataTime)}
            </div>
        )
    } // end of RenderContent4HaveDataWrapper

    /*===========================================
    summary: Render Content 沒資料 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderContent4EmptyWrapper()
    {
        return (
            <div className={cssResourceVolume.divContent4Empty}>
                <div className={cssResourceVolume.divEmptyListText}>
                    {window.gAppUI.MSG_Resource_NoAuthorized}
                </div>
            </div>
        )
    } // end of RenderContent4EmptyWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            if (
                    (
                        (mblnExpired) &&
                        (!mobjResourceVolume.IsHaveAuthorized)
                    ) ||
                    (mobjResourceVolume.Volume === null) 
                )
            {
                return RenderContent4EmptyWrapper()
            }
            else
            {
                return RenderContent4HaveDataWrapper(StateUpdateDataTime)
            }
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssResourceVolume.divTopTool}>
                <ComponentBackButton />
                <ComponentTitle />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssResourceVolume.divMain}>
                {RenderTopToolWrapper()}
                
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return RenderMainWrapper()
    // #endregion Render
}
export default ResourceVolume